import { LucideIcon } from "lucide-react";
import React from "react";
import { FormattedMessage } from "react-intl";

interface PipelineModeCardProps {
  mode: string;
  currentMode: string;
  onSelect: (mode: any) => void;
  icon: LucideIcon;
  iconColor: string;
  titleId: string;
  titleDefault: string;
  descriptionId: string;
  descriptionDefault: string;
  badge?: {
    textId: string;
    textDefault: string;
    bgColor: string;
    textColor: string;
  };
  features: Array<{
    textId: string;
    textDefault: string;
  }>;
}

export const PipelineModeCard = ({
  mode,
  currentMode,
  onSelect,
  icon: Icon,
  iconColor,
  titleId,
  titleDefault,
  descriptionId,
  descriptionDefault,
  badge,
  features,
}: PipelineModeCardProps) => {
  const isSelected = mode === currentMode;

  return (
    <div
      onClick={() => onSelect(mode)}
      className={`
        relative flex cursor-pointer rounded-[8px] border p-4 shadow-sm focus:outline-none transition-all
        ${
          isSelected
            ? "border-[#60A5FA] ring-1 ring-[#60A5FA] bg-sky-50"
            : "border-slate-200 hover:border-slate-300 hover:bg-slate-50 bg-white"
        }
      `}
    >
      {badge && (
        <span
          className={`absolute top-[16px] right-3 inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${badge.bgColor} ${badge.textColor}`}
        >
          <FormattedMessage
            id={badge.textId}
            defaultMessage={badge.textDefault}
          />
        </span>
      )}
      <div className="flex flex-1 flex-col">
        <div className="flex items-center gap-[8px]">
          <Icon className={`${iconColor} h-[20px] w-[20px]`} />
          <span className="block text-sm font-medium text-[#18181B]">
            <FormattedMessage id={titleId} defaultMessage={titleDefault} />
          </span>
        </div>
        <span className="mt-[8px] mb-[8px] text-xs text-[#71717A] max-w-[450px]">
          <FormattedMessage
            id={descriptionId}
            defaultMessage={descriptionDefault}
          />
        </span>
        <div className="flex items-center gap-[8px]">
          {features.map((feature, index) => (
            <React.Fragment key={index}>
              {index > 0 && (
                <div className="w-[4px] h-[4px] rounded-full bg-[#D4D4D4]"></div>
              )}
              <p className="text-xs text-[#9CA3AF]">
                <FormattedMessage
                  id={feature.textId}
                  defaultMessage={feature.textDefault}
                />
              </p>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
